'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var clsx = require('clsx');
var check = require('../../svg/check.js');
var nthHookTheme = require('@narvar/nth-hook-theme');
var OptionProvider = require('../../components/OptionProvider.js');
var styles_module = require('./styles.module.css.js');
var Placeholder = require('./Placeholder.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function Image() {
  const {
    selecteditemNoneNone: selecteditem,
    panelcontainerNoneNone: panelContainer
  } = nthHookTheme.useTheme();
  const {
    option: {
      label,
      isGrayedOut
    },
    isSelected,
    isFocused,
    isDisabled,
    isHovered
  } = OptionProvider.useOption();
  const invalidImage = !label || typeof label !== 'string';
  const imageWrapperClassNames = clsx.clsx(styles_module["default"].imageWrapper, isSelected && styles_module["default"].imageWrapperSelected, isDisabled && styles_module["default"].imageWrapperDisabled, isGrayedOut && styles_module["default"].imageWrapperGreyedOut);
  const imageLabelClassNames = clsx.clsx(styles_module["default"].imageLabel, isSelected && styles_module["default"].imageLabelSelected);
  const imageWrapperTheme = {
    borderColor: (isSelected || isFocused || isHovered) && !isDisabled && !isGrayedOut ? (selecteditem === null || selecteditem === void 0 ? void 0 : selecteditem.borderTopColor) ?? 'black' : (panelContainer === null || panelContainer === void 0 ? void 0 : panelContainer.borderTopColor) ?? 'lightgray'
  };
  const checkmarkTheme = {
    background: (selecteditem === null || selecteditem === void 0 ? void 0 : selecteditem.borderTopColor) ?? 'black'
  };
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: styles_module["default"].container
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: imageWrapperClassNames,
    style: imageWrapperTheme
  }, invalidImage ? /*#__PURE__*/React__default["default"].createElement("div", {
    className: imageLabelClassNames
  }, /*#__PURE__*/React__default["default"].createElement(Placeholder["default"], {
    width: "100%",
    height: "100%"
  })) : /*#__PURE__*/React__default["default"].createElement("div", {
    className: imageLabelClassNames,
    style: {
      backgroundImage: `url(${label})`
    }
  })), isSelected && /*#__PURE__*/React__default["default"].createElement("div", {
    className: styles_module["default"].checkmark,
    style: checkmarkTheme
  }, /*#__PURE__*/React__default["default"].createElement(check.Check, null)), (isDisabled || isGrayedOut) && /*#__PURE__*/React__default["default"].createElement("div", {
    className: styles_module["default"].diagonalLine
  }));
}
var Image$1 = nthHookTheme.withThemeProvider(Image, {
  themeTokens: ['selecteditemNoneNone', 'panelcontainerNoneNone']
});

exports["default"] = Image$1;
